// src/components/AboutBanner.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./AboutBanner.css";


const AboutBanner = () => {
  return (
    <section className="about-banner">
      <Container >
        <Row className="align-items-center">
          <Col md={12} className="text-content">
            <h2 className="banner-title">About</h2>
            <p className="breadcrumb">
              Home <span> » </span> <span className="active">About</span>
            </p>
          </Col>
          
        </Row>
      </Container>
    </section>
  );
};

export default AboutBanner;
